export enum JourneyTypes {
  RESERVE_ONLINE = 'reserve_online',
  ORDER_ONLINE =  'online_order',
  CONTINUE_IN_DEALERSHIP = 'continue_in_dealership',
}
